export interface HoursRange {
  from: string;
  to: string;
}

export interface WorkingHours {
  enabled: boolean;
  ranges: WorkingHoursRange[];
  timezone?: string;
}

export interface WorkingHoursRange {
  days: number[];
  hours: HoursRange[];
}

export const defaultHours: HoursRange = { from: '00:00', to: '23:59' };
export const defaultDays: number[] = [1, 2, 3, 4, 5];
